import { useTranslation } from "react-i18next";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import IconButton from "features/components/IconButton";
import Tooltip from "features/components/Tooltip";
import {
  FilterGroupState,
  FilterRowState,
} from "features/ui/Filters/FilterBuilder/types";
import FiltersOverview from "features/ui/Filters/FiltersOverview";
import { SchemaEntry } from "features/ui/MaterialTable";

interface FilterTooltipContentProps {
  hasActiveFilters: boolean;
  filters?: FilterGroupState<FilterRowState>;
  filterSchema: SchemaEntry[];
  onRemoveAllFilters: () => void;
  onClose?: () => void;
}

const FilterTooltipContent = ({
  hasActiveFilters,
  filters,
  filterSchema,
  onRemoveAllFilters,
  onClose,
}: FilterTooltipContentProps) => {
  const { t } = useTranslation();
  const handleRemoveClick = () => {
    onRemoveAllFilters();
    onClose?.();
  };
  if (hasActiveFilters && filters) {
    return (
      <div className="max-w-md">
        <div className="flex justify-between items-center mb-1">
          <div className="text-sm font-medium">
            {t("schema:dashboard.active_filters")}
          </div>
          <Tooltip
            title={t("schema:dashboard.remove_active_filters")}
            placement="top"
          >
            <IconButton
              size="small"
              onClick={handleRemoveClick}
              className="p-1"
              style={{ color: "#9E0812" }}
            >
              <DeleteOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </div>
        <FiltersOverview
          filters={filters}
          tableSchema={filterSchema}
          removable={false}
          hideClearAll={true}
          format="label-inline"
          dense={true}
          className="flex flex-col gap-1"
        />
        <div className="text-xs text-gray-400 mt-2">
          {t("schema:dashboard.active_filters_hint")}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md">
      <div className="text-sm font-medium mb-1">
        {t("schema:dashboard.active_filters_none")}
      </div>
      <div className="text-xs text-gray-400 mt-2">
        (to change filters turn Smart grouping off)
      </div>
    </div>
  );
};

export default FilterTooltipContent;
